<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Christian Moueix - Dominus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si dice che ogni grande vino abbia una storia ancora più grande alle spalle e la tenuta Dominus non fa eccezione. Di proprietà del grande Christian Moueix della fama di Château Pétrus, Dominus è una delle più grandi aziende vinicole della Napa Valley al mondo.
                    </div>

                    <div class="howto-title2">Un Cabernet californiano dall'anima bordolese</div>
                    <div class="howto-text">
                        Dopo aver studiato enologia in California, Christian si è innamorato della regione alla fine degli anni '60,
                        sapendo istintivamente che avrebbe potuto prendere il suo savoir-faire bordolese e trasferirlo in un nuovo
                        territorio mondiale. Lavorando per la famosa tenuta di Napanook di John Daniels durante la sua pausa estiva, lui
                        strinse amicizia con Robert Mondovì, e prima di lasciare gli States gli chiese di tenere un
                        occhio a tutte le opportunità che potrebbero diventare disponibili. Ciò non sarebbe accaduto fino a oltre a
                        decennio dopo, però, quando nel 1982 Mondovì chiamò dicendo che si era presentata un'occasione ai suoi
                        vecchio terreno di stampaggio, e Napabrook cercavano investitori.
                    </div>

                    <div class="howto-title2">Proprietà esclusiva della tenuta nel 1995</div>
                    <div class="howto-text">
                        Moueix ha stretto una partnership con la figlia di Daniels, Robin Lail e Marcia Smith. Credendoci
                        il successo della Napa Valley Winery sta nel mantenere la produzione autenticamente bordolese
                        possibile (questo è ancora vero oggi). Così, Christian ha cercato l'aiuto del suo Château Pétrus
                        enologo Jean Claude Berrouet. Questo approccio ha avuto un tale successo che Moueix è diventato l'unico
                        proprietario di Napabrook, ora Dominus nel 1995. Si è subito avvalso dell'aiuto degli architetti Jacques
                        Herzong e Pierre de Meuron e costruì una delle migliori cantine che la Napa Valley avesse mai visto.
                        Dal momento che Moueix è l'unico gestore, l'azienda ha costantemente migliorato il suo punteggio, da
                        gli alti anni '80, ai bassi (poi alti) anni '90, fino al suo perfetto 100n per l'annata 2010. Un inedito
                        tripletta di tre punteggi perfetti per l'annata 2013 ha suggellato il suo successo.
                        <br><br>
                        Le credenziali di Christian fanno ben sperare per Dominus. I prezzi per il mitico 2013 sono ben oltre i 400€
                        marchio in Europa (meno in America). Ciò dimostra un notevole aumento del suo mercato secondario
                        prezzo di rilascio con la tendenza al rialzo che sembra destinata a continuare per qualche tempo.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Christian Moueix - Dominus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Man sagt, dass hinter jedem großen Wein eine noch größere Geschichte steckt, und das Weingut Dominus bildet da keine Ausnahme. Dominus gehört dem großen Christian Moueix vom berühmten Château Pétrus und ist eines der größten Weingüter im Napa Valley der Welt.
                    </div>

                    <div class="howto-title2">Ein kalifornischer Cabernet mit einer Bordeaux-Seele</div>
                    <div class="howto-text">
                        Nach seinem Önologiestudium in Kalifornien verliebte sich Christian Ende der 1960er Jahre in die Region.
                        instinktiv wusste er, dass er sein Bordelaise-Know-how auf ein neues übertragen konnte
                        Weltgebiet. Während seiner Sommerferien arbeitete er für John Daniels‘ berühmtes Anwesen in Napanook
                        schloss eine Freundschaft mit Robert Mondovi und bat ihn vor seiner Abreise aus den USA, eine Freundschaft zu führen
                        Halten Sie Ausschau nach möglichen Möglichkeiten. Das würde erst über einem Jahr passieren
                        Ein Jahrzehnt später jedoch rief Mondovi 1982 an und sagte, dass sich bei ihm eine Gelegenheit ergeben habe
                        altes Revier und Napabrook suchten nach Investoren.
                    </div>

                    <div class="howto-title2">Alleineigentümer des Anwesens im Jahr 1995</div>
                    <div class="howto-text">
                        Moueix ging eine Partnerschaft mit Daniels‘ Tochter Robin Lail und Marcia Smith ein. Ich glaube das
                        Der Erfolg der Napa Valley Winery lag darin, die Produktion so authentisch wie Bordelaise zu halten
                        möglich (das gilt auch heute noch). Daher suchte Christian die Hilfe seines Château Pétrus
                        Winzer Jean Claude Berrouet. Dieser Ansatz erwies sich als so erfolgreich, dass Moueix der einzige Anbieter wurde
                        Eigentümer von Napabrook, dem heutigen Dominus im Jahr 1995. Er nahm sofort die Hilfe des Architekten Jacques in Anspruch
                        Herzong und Pierre de Meuron gründeten eines der besten Weingüter, die das Napa Valley je gesehen hatte.
                        Seit Moueix der alleinige Geschäftsführer ist, hat das Weingut seine Bewertung kontinuierlich verbessert
                        von den hohen 80ern über die niedrigen (dann hohen) 90er bis hin zu den perfekten 100n für den Jahrgang 2010. Ein beispielloses
                        Der Hattrick mit drei perfekten Ergebnissen für den Jahrgang 2013 besiegelte seinen Erfolg.
                        <br><br>
                        Christians Referenzen verheißen Gutes für Dominus. Die Preise für den sagenumwobenen 2013 liegen deutlich bei über 400 €
                        Marke in Europa (weniger in Amerika). Dies zeigt einen bemerkenswerten Anstieg des Sekundärmarktes
                        Veröffentlichungspreis, wobei der Aufwärtstrend voraussichtlich noch einige Zeit anhalten wird.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Christian Moueix - Dominus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il a été dit que chaque grand vin a une histoire encore plus grande derrière lui et le domaine Dominus ne fait pas exception. Propriété du grand Christian Moueix du célèbre Château Pétrus, Dominus est l'un des plus grands vignobles de Napa Valley au monde.
                    </div>

                    <div class="howto-title2">Un cabernet californien à l'âme bordelaise</div>
                    <div class="howto-text">
                        Après des études d'œnologie en Californie, Christian tombe amoureux de la région à la fin des années 1960,
                        sachant instinctivement qu'il pouvait prendre son savoir-faire bordelais et le transférer dans un nouveau
                        territoire mondial. Travaillant pour le célèbre domaine de Napanook de John Daniels pendant ses vacances d'été, il
                        se lia d'amitié avec Robert Mondovi et, avant de quitter les États-Unis, lui demanda de garder une
                        à l'affût de toutes les opportunités qui pourraient se présenter. Cela n'arriverait pas avant plus d'un
                        décennie plus tard, cependant, lorsqu'en 1982 Mondovi a appelé en disant qu'une opportunité s'était présentée
                        ancien terrain de prédilection, et Napabrook cherchaient des investisseurs.
                    </div>

                    <div class="howto-title2">Propriétaire unique du domaine en 1995</div>
                    <div class="howto-text">
                        Moueix a formé un partenariat avec la fille de Daniels, Robin Lail et Marcia Smith. Croyant que
                        le succès de la Napa Valley Winery réside dans le maintien d'une production aussi authentiquement bordelaise que
                        possible (c'est encore vrai aujourd'hui). Ainsi, Christian a sollicité l'aide de son Château Pétrus
                        vigneron Jean Claude Berrouet. Cette approche s'est avérée un tel succès que Moueix est devenu le seul
                        propriétaire de Napabrook, devenu Dominus en 1995. Il s'est immédiatement fait aider par les architectes Jacques
                        Herzong et Pierre de Meuron et ont construit l'un des meilleurs vignobles que la Napa Valley ait jamais vu.
                        Depuis que Moueix en est l'unique gérant, le domaine n'a cessé d'améliorer sa notation, passant de
                        des années 80 hautes, aux années 90 basses (puis hautes), à son parfait 100n pour le millésime 2010. Un sans précédent
                        coup du chapeau de trois notes parfaites pour le millésime 2013 a scellé son succès.
                        <br><br>
                        Les références de Christian sont de bon augure pour Dominus. Les prix du légendaire 2013 dépassent largement les 400 €
                        marque en Europe (moins en Amérique). Cela montre une augmentation remarquable de son marché secondaire
                        prix de sortie avec la tendance à la hausse qui devrait se poursuivre pendant un certain temps.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Christian Moueix - Dominus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        It has been said that every great wine has an even greater story behind it and the Dominus estate is no exception. Owned by the great Christian Moueix of Château Pétrus fame, Dominus is one of the world’s greatest Napa Valley wineries.
                    </div>

                    <div class="howto-title2">A Californian Cabernet with a Bordeaux soul</div>
                    <div class="howto-text">
                        After studying oenology in California, Christian fell in love with the region in the late 1960s,
                        instinctively knowing that he could take his Bordelaise savoir-faire and transfer it to a new
                        world territory. Working for John Daniels’ famous Napanook estate during his summer break, he
                        struck up a friendship with Robert Mondovi, and prior to leaving the States asked him to keep an
                        eye out for any opportunities that might become available. That wouldn’t happen until over a
                        decade later, however, when in 1982 Mondovi called saying that an opportunity had arisen at his
                        old stamping ground, and Napabrook were looking for investors.
                    </div>

                    <div class="howto-title2">Sole ownership of the estate in 1995</div>
                    <div class="howto-text">
                        Moueix formed a partnership with Daniels’ daughter, Robin Lail and Marcia Smith. Believing that
                        the success of the Napa Valley Winery lay in keeping production as authenticly Bordelaise as
                        possible (this is still true today). Thus, Christian sought the help of his Château Pétrus
                        winemaker Jean Claude Berrouet. This approach proved so successful that Moueix became the sole
                        owner of Napabrook, now Dominus in 1995. He immediately enlisted the help of architects Jacques
                        Herzong and Pierre de Meuron and built one of the best wineries the Napa Valley had ever seen.
                        Since Moueix has been the sole manager, the winery has consistently improved its scoring, from
                        the high 80s, to low (then high) 90s, to its perfect 100n for the 2010 vintage. An unprecedented
                        hat trick of three perfect scores for the 2013 vintage sealed his success.
                        <br><br>
                        Christian’s credentials bode well for Dominus. Prices for the fabled 2013 are well the over €400
                        mark in Europe (less in America). This shows a remarkable increase in its secondary market
                        release price with the upward trend looking set to continue for some time.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChristianMoueixDominus",
    head: {
        title: 'Christian Moueix - Dominus | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Experience the excellence of winemaking with Christian Moueix\'s Dominus Vineyards. Producing world-class Napa Valley wines, discover the rich flavors and history behind every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
